/**
 * Count input with increment (+) and decrement (-) buttons
 */

export default (() => {
  const countInputs = document.querySelectorAll('.count-input')

  if (countInputs.length === 0)
    return;

  const handleIncrement = (event) =>
  {
    const input = event.currentTarget.parentNode.querySelector('.form-control');
    const maxValue = parseInt(input.getAttribute('max')) || Infinity;
    const multiplyValue = input.dataset.multiply ? parseFloat(input.dataset.multiply) : 1;

    if (input.value < maxValue)
    {
      input.value = parseFloat(input.value) + multiplyValue;
      input.value = Math.min(input.value, maxValue);

      if (input.attributes.value)
        input.attributes.value.value = input.value;

      input.dispatchEvent(new Event("change", { bubbles: true }));

      updateButtonStates(input)
    }
  }

  const handleDecrement = (event) =>
  {
    const input = event.currentTarget.parentNode.querySelector('.form-control');
    const minValue = parseInt(input.getAttribute('min')) || 0;
    const multiplyValue = input.dataset.multiply ? parseFloat(input.dataset.multiply) : 1;

    if (input.value > minValue)
    {
      input.value = parseFloat(input.value) - multiplyValue;
      input.value = Math.max(input.value, minValue);

      if (input.attributes.value)
        input.attributes.value.value = input.value;

      input.dispatchEvent(new Event("change", { bubbles: true }));

      updateButtonStates(input)
    }
  }

  const updateButtonStates = (input) =>
  {
    const decrementBtn = input.parentNode.querySelector('[data-decrement]')
    const incrementBtn = input.parentNode.querySelector('[data-increment]')
    const minValue = parseInt(input.getAttribute('min')) || 0
    const maxValue = parseInt(input.getAttribute('max')) || Infinity

    if (decrementBtn)
      decrementBtn.disabled = input.value <= minValue;

    if (incrementBtn)
      incrementBtn.disabled = input.value >= maxValue

    const parent = input.closest('.count-input');

    if (!parent.classList.contains('count-input-collapsible'))
      return

    const inputValue = incrementBtn.querySelector('[data-count-input-value]')

    if (input.value > 0) {
      parent.classList.remove('collapsed')
      if (inputValue) {
        inputValue.textContent = input.value
      }
    } else {
      parent.classList.add('collapsed')
      if (inputValue) {
        inputValue.textContent = ''
      }
    }
  }

  countInputs.forEach((component) => {
    const incrementBtn = component.querySelector('[data-increment]')
    const decrementBtn = component.querySelector('[data-decrement]')
    const input = component.querySelector('.form-control')

    if (incrementBtn)
      incrementBtn.addEventListener('click', handleIncrement);

    if (decrementBtn)
      decrementBtn.addEventListener('click', handleDecrement)

    updateButtonStates(input)
  })

  document.addEventListener("onElementAdded", event =>
  {
    const countElements = document.querySelectorAll('.count-input');

    if (!countElements || countElements.length == 0)
      return;

    countElements.forEach((component) =>
    {
      const incrementBtn = component.querySelector('[data-increment]')
      const decrementBtn = component.querySelector('[data-decrement]')
      const input = component.querySelector('.form-control')

      if (incrementBtn)
        incrementBtn.addEventListener('click', handleIncrement);

      if (decrementBtn)
        decrementBtn.addEventListener('click', handleDecrement);

      updateButtonStates(input)
    })
  })
})()
